import { useEffect } from "react";
import { useRecoilValue } from "recoil";
import { accessTokenAtom } from "../../recoil";
import { axios } from "../../apis/utils";
import { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import requiredAuth from "../../components/requiredAuth";
import { Button } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useRef } from "react";
import LoadingAlert from "../../components/Alert/LoadingAlert";
import Swal from "sweetalert2";

const TeamPage = () => {
  const accessToken = useRecoilValue(accessTokenAtom);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const teamId = queryParams.get("id");
  const [member, setMember] = useState([]);
  const [canAddMember, setCanAddMember] = useState([]);
  const [userData, setUserData] = useState([]);
  const selectVal = useRef();

  const deleteTeam = async (id) => {
    const check = window.confirm("Are you sure you want to delete the user?");
    if (check) {
      if (id) {
        try {
          await axios.post(
            "/teamUserDelete",
            {
              id: id,
            },
            {
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
            }
          );
          window.location.reload();
        } catch (error) {
          console.error("Error delete team", error);
        }
      }
    }
  };

  const closeWindow = () => {
    window.close();
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`/teamMember`, {
          params: {
            teamId: teamId,
          },
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        setMember(res.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    const fetchDataUser = async () => {
      try {
        const res = await axios.get(`/allMember`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        setUserData(res.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
    fetchDataUser();
  }, []);

  const addMember = () => {
    setMember((prevMember) => [
      ...prevMember,
      JSON.parse(selectVal?.current.value),
    ]);
  };

  const saveMember = async () => {
    LoadingAlert();
    try {
      await axios.post(
        `/teamMemberSet`,
        {
          teamId: teamId,
          member: member,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      Swal.close();
      window.location.reload();
    } catch (error) {
      console.error("Error renaming team", error);
    }
  };

  useEffect(() => {
    if (userData && member) {
      const filteredArray = userData.filter(
        (item2) => !member.some((item1) => item1.email === item2.email)
      );
      setCanAddMember(filteredArray);
    }
  }, [userData, member]);

  return (
    <div style={{ padding: "20px" }}>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell>No. </TableCell>
              <TableCell>email</TableCell>
              <TableCell align="center">nickname</TableCell>
              <TableCell align="center">role</TableCell>
              <TableCell align="center">option</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {member.map((row, index) => (
              <TableRow
                key={index}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {member.length - index}
                </TableCell>
                <TableCell component="th" scope="row">
                  {row.email}
                </TableCell>
                <TableCell align="center">{row.nickname}</TableCell>
                <TableCell align="center">{row.role}</TableCell>
                <TableCell align="center">
                  <div>
                    <Button
                      variant="outlined"
                      type="button"
                      onClick={() => deleteTeam(row.id)}
                      sx={{
                        marginRight: "5px",
                      }}
                    >
                      Delete
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <div style={{ marginTop: "10px" }}>
        <select
          ref={selectVal}
          style={{
            padding: "10px 20px",
            width: "100%",
            fontSize: "20px",
            border: "1px solid #aaa",
            borderRadius: "3px",
            webkitAppearance: "none",
            mozAppearance: "none",
            appearance: "none",
            outline: "#aaa",
            cursor: "pointer",
          }}
        >
          {canAddMember?.map((user) => {
            return (
              <option key={user.email} value={JSON.stringify(user)}>
                {user.email}
              </option>
            );
          })}
        </select>
      </div>
      <div style={{ textAlign: "center", marginTop: "10px" }}>
        <Button
          variant="outlined"
          type="button"
          style={{ marginRight: "10px" }}
          onClick={() => addMember()}
        >
          add
        </Button>
        <Button
          variant="outlined"
          type="button"
          style={{ marginRight: "10px" }}
          onClick={() => saveMember()}
        >
          save
        </Button>
        <Button variant="outlined" type="button" onClick={() => closeWindow()}>
          close
        </Button>
      </div>
    </div>
  );
};

export default requiredAuth(TeamPage);
